import { useEffect, useState } from "react";
import { LanguageSwitch } from "./LanguageSwitch";
import { InstallButton } from "./InstallButton";
import { BRAND } from "../config/brand";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="app-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-white/5 bg-ink/70 backdrop-blur-xl" : "bg-transparent"
      }`}
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-3 px-5 sm:px-8">
        <a href="#top" data-testid="header-brand" className={`flex items-center gap-2 font-display text-base font-bold tracking-tight text-zinc-50 transition-opacity duration-500 ${scrolled ? "opacity-100" : "opacity-0 pointer-events-none"}`}>
          <img src={BRAND.logoSmall} alt="" className="h-8 w-8" />
          <span>SYN<span className="font-serif text-[1.15em] font-normal italic text-gold">rise</span></span>
        </a>
        <div className="flex items-center gap-2">
          <InstallButton />
          <LanguageSwitch />
        </div>
      </div>
    </header>
  );
};
